
// ----------------------
// EDDY施設紹介用のスライダー
// ----------------------
// 1列目
$(function () {
	const slideLength = document.querySelectorAll('.eddy-facility-box .swiper-1 .swiper-container .swiper-slide').length

	if (slideLength == 1) { //スライドが1枚だった場合はslideNoneというクラスを付与する
		$(".eddy-facility-box .swiper-1 .swiper-button-next").hide();
		$(".eddy-facility-box .swiper-1 .swiper-button-prev").hide();
	}
	if (slideLength > 1) {
		var mySwiper = new Swiper('.eddy-facility-box .swiper-1 .swiper-container', {
			slidesPerView: 1,
			loop: true,
			effect: 'slide', autoplay: {
				delay: 4000,
			},
			navigation: {
				nextEl: '.swiper-1 .swiper-button-next',
				prevEl: '.swiper-1 .swiper-button-prev'
			},
		})
	}
});

// 2列目
$(function () {
	const slideLength = document.querySelectorAll('.eddy-facility-box .swiper-2 .swiper-container .swiper-slide').length

	if (slideLength == 1) { //スライドが1枚だった場合はslideNoneというクラスを付与する
		$(".eddy-facility-box .swiper-2 .swiper-button-next").hide();
		$(".eddy-facility-box .swiper-2 .swiper-button-prev").hide();
	}
	if (slideLength > 1) {
		var mySwiper = new Swiper('.eddy-facility-box .swiper-2 .swiper-container', {
			slidesPerView: 1,
			loop: true,
			effect: 'slide', autoplay: {
				delay: 4000,
			},
			navigation: {
				nextEl: '.swiper-2 .swiper-button-next',
				prevEl: '.swiper-2 .swiper-button-prev'
			},
		})
	}
});

// 3列目
$(function () {
	const slideLength = document.querySelectorAll('.eddy-facility-box .swiper-3 .swiper-container .swiper-slide').length

	if (slideLength == 1) { //スライドが1枚だった場合はslideNoneというクラスを付与する
		$(".eddy-facility-box .swiper-3 .swiper-button-next").hide();
		$(".eddy-facility-box .swiper-3 .swiper-button-prev").hide();
	}
	if (slideLength > 1) {
		var mySwiper = new Swiper('.eddy-facility-box .swiper-3 .swiper-container', {
			slidesPerView: 1,
			loop: true,
			effect: 'slide', autoplay: {
				delay: 4000,
			},
			navigation: {
				nextEl: '.swiper-3 .swiper-button-next',
				prevEl: '.swiper-3 .swiper-button-prev'
			},
		})
	}
});

// 4列目
$(function () {
	const slideLength = document.querySelectorAll('.eddy-facility-box .swiper-4 .swiper-container .swiper-slide').length

	if (slideLength == 1) { //スライドが1枚だった場合はslideNoneというクラスを付与する
		$(".eddy-facility-box .swiper-4 .swiper-button-next").hide();
		$(".eddy-facility-box .swiper-4 .swiper-button-prev").hide();
	}
	if (slideLength > 1) {
		var mySwiper = new Swiper('.eddy-facility-box .swiper-4 .swiper-container', {
			slidesPerView: 1,
			loop: true,
			effect: 'slide', autoplay: {
				delay: 4000,
			},
			navigation: {
				nextEl: '.swiper-4 .swiper-button-next',
				prevEl: '.swiper-4 .swiper-button-prev'
			},
		})
	}
});

// 5列目
$(function () {
	const slideLength = document.querySelectorAll('.eddy-facility-box .swiper-5 .swiper-container .swiper-slide').length

	if (slideLength == 1) { //スライドが1枚だった場合はslideNoneというクラスを付与する
		$(".eddy-facility-box .swiper-5 .swiper-button-next").hide();
		$(".eddy-facility-box .swiper-5 .swiper-button-prev").hide();
	}
	if (slideLength > 1) {
		var mySwiper = new Swiper('.eddy-facility-box .swiper-5 .swiper-container', {
			slidesPerView: 1,
			loop: true,
			effect: 'slide', autoplay: {
				delay: 4000,
			},
			navigation: {
				nextEl: '.swiper-5 .swiper-button-next',
				prevEl: '.swiper-5 .swiper-button-prev'
			},
		})
	}
});

// 6列目
$(function () {
	const slideLength = document.querySelectorAll('.eddy-facility-box .swiper-6 .swiper-container .swiper-slide').length

	if (slideLength == 1) { //スライドが1枚だった場合はslideNoneというクラスを付与する
		$(".eddy-facility-box .swiper-6 .swiper-button-next").hide();
		$(".eddy-facility-box .swiper-6 .swiper-button-prev").hide();
	}
	if (slideLength > 1) {
		var mySwiper = new Swiper('.eddy-facility-box .swiper-6 .swiper-container', {
			slidesPerView: 1,
			loop: true,
			effect: 'slide', autoplay: {
				delay: 4000,
			},
			navigation: {
				nextEl: '.swiper-6 .swiper-button-next',
				prevEl: '.swiper-6 .swiper-button-prev'
			},
		})
	}
});

// 7列目
$(function () {
	const slideLength = document.querySelectorAll('.eddy-facility-box .swiper-7 .swiper-container .swiper-slide').length

	if (slideLength == 1) { //スライドが1枚だった場合はslideNoneというクラスを付与する
		$(".eddy-facility-box .swiper-7 .swiper-button-next").hide();
		$(".eddy-facility-box .swiper-7 .swiper-button-prev").hide();
	}
	if (slideLength > 1) {
		var mySwiper = new Swiper('.eddy-facility-box .swiper-7 .swiper-container', {
			slidesPerView: 1,
			loop: true,
			effect: 'slide', autoplay: {
				delay: 4000,
			},
			navigation: {
				nextEl: '.swiper-7 .swiper-button-next',
				prevEl: '.swiper-7 .swiper-button-prev'
			},
		})
	}
});


// 8列目
$(function () {
	const slideLength = document.querySelectorAll('.eddy-facility-box .swiper-8 .swiper-container .swiper-slide').length

	if (slideLength == 1) { //スライドが1枚だった場合はslideNoneというクラスを付与する
		$(".eddy-facility-box .swiper-8 .swiper-button-next").hide();
		$(".eddy-facility-box .swiper-8 .swiper-button-prev").hide();
	}
	if (slideLength > 1) {
		var mySwiper = new Swiper('.eddy-facility-box .swiper-8 .swiper-container', {
			slidesPerView: 1,
			loop: true,
			effect: 'slide', autoplay: {
				delay: 4000,
			},
			navigation: {
				nextEl: '.swiper-8 .swiper-button-next',
				prevEl: '.swiper-8 .swiper-button-prev'
			},
		})
	}
});


// 9列目
$(function () {
	const slideLength = document.querySelectorAll('.eddy-facility-box .swiper-9 .swiper-container .swiper-slide').length

	if (slideLength == 1) { //スライドが1枚だった場合はslideNoneというクラスを付与する
		$(".eddy-facility-box .swiper-9 .swiper-button-next").hide();
		$(".eddy-facility-box .swiper-9 .swiper-button-prev").hide();
	}
	if (slideLength > 1) {
		var mySwiper = new Swiper('.eddy-facility-box .swiper-9 .swiper-container', {
			slidesPerView: 1,
			loop: true,
			effect: 'slide', autoplay: {
				delay: 4000,
			},
			navigation: {
				nextEl: '.swiper-9 .swiper-button-next',
				prevEl: '.swiper-9 .swiper-button-prev'
			},
		})
	}
});

// 10列目
$(function () {
	const slideLength = document.querySelectorAll('.eddy-facility-box .swiper-10 .swiper-container .swiper-slide').length

	if (slideLength == 1) { //スライドが1枚だった場合はslideNoneというクラスを付与する
		$(".eddy-facility-box .swiper-10 .swiper-button-next").hide();
		$(".eddy-facility-box .swiper-10 .swiper-button-prev").hide();
	}
	if (slideLength > 1) {
		var mySwiper = new Swiper('.eddy-facility-box .swiper-10 .swiper-container', {
			slidesPerView: 1,
			loop: true,
			effect: 'slide', autoplay: {
				delay: 4000,
			},
			navigation: {
				nextEl: '.swiper-10 .swiper-button-next',
				prevEl: '.swiper-10 .swiper-button-prev'
			},
		})
	}
});
